<template>
    <div class="popup-parcelamento">

        <div>
            <div >
                
                <div class="row">
                    <div class="sm-6">
                        <download-link
                            :href="url"
                            target="_system"
                            class="button primary full"
                        >BAIXAR BOLETO</download-link>
                    </div>
                    <div class="sm-6">
                        <button class="default-button full" v-if="sending">ENVIANDO...</button>
                        <button
                            class="button secondary full"
                            v-else
                            @click="enviarEmail"
                        >ENVIAR POR E-MAIL</button>
                    </div>
                </div>
                <div class="row">
                    <div class="sm-12">                
                        <p>&nbsp;</p>
                    </div>
                </div>
            </div>
            
            <center>
                <button class="default-button" @click.prevent.stop="$emit('close')">FECHAR</button>
            </center>
        </div>
    </div>
</template>
<script>
import { DateTime } from "luxon";
import api from "/plugins/api";
import Swal from "sweetalert2";
import qs from "qs";
import { api_endpoint } from "~/plugins/api";

export default {
    props: ["boleto"],
    components: {
        
    },
    data() {
        return {
            data: DateTime.local().toFormat("yyyy-LL-dd"),
            hoje: DateTime.local().toFormat("yyyy-LL-dd"),
            Hoje: DateTime.local().toISO(),
            activeTab: "boleto",
            sending: false,
            errors: []
        };
    },
    computed: {
        Data: {
            get() {
                return DateTime.fromSQL(this.data).toISO()
            },
            set(v) {
                let data = DateTime.fromISO(v, { zone: 'UTC'}).toFormat('yyyy-LL-dd');                
                this.data = data;
            }
        },
        codigo() {
            return this.boleto.codigo;
        },
        cliente() {
            return this.$store.state.cliente;
        },
        mes() {
            return this.$route.params.mes;
        },
        ano() {
            return this.$route.params.ano;
        },
        relacao() {
            return this.$store.getters.relacao;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        jwt() {
            return this.$store.state.jwt;
        },
        url() {
            let tipo = this.relacao.sistema == "C" ? "condominio" : "aluguel";
            let tipo_relacao = this.relacao.tipoRelacao;

            let query = {
                jwt: this.jwt
            };
            query = qs.stringify(query);

            //let endpoint = `${location.origin}${location.pathname}api`
            let endpoint = api_endpoint

            if (location.origin == "file://" || 'undefined' != typeof window.api_endpoint) {
                endpoint = window.api_endpoint;
            }

            return `${endpoint}/boletos-pagos/${tipo}/${tipo_relacao}/${this.codigo}?${query}`;
        }
    },
    methods: {
     
        async enviarEmail() {
            try {

                let tipo =
                    this.relacao.sistema == "C" ? "condominio" : "aluguel";
                let tipo_relacao = this.relacao.tipoRelacao;

                let params = {};
                                

                this.sending = true;
                let { data } = await api.post(
                    `boletos-pagos/${tipo}/${tipo_relacao}/${this.codigo}`,
                    params
                );
                Swal.fire({
                    icon: "success",
                    title: "Sucesso",
                    text: `Boleto enviado para o e-mail: ${this.cliente.contato.email}`,
                    didClose: () => {
                        this.$emit("close");
                    }
                });
            } catch (err) {
                if (err.response && err.response.data) {
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: err.response.data.error,
                        didClose: () => {
                            this.$emit("close");
                        }
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Oops",
                        text: "Não foi possível enviar o boleto",
                        didClose: () => {
                            this.$emit("close");
                        }
                    });
                }
                console.error(err);
            }
            this.sending = false;
        }
    }
};
</script>
<style lang="less">
.swal2-popup {
    width: 60em !important;
    max-width: 100vw !important;
}
</style>
<style lang="less" scoped>
.tabs {
    display: flex;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0;
        margin: 1px;
        opacity: 0.7;
        &.active {
            opacity: 1;
        }
    }
}
</style>